<template>
  <main class="navbar__main">
    <Sidebar :resource="drawer" />

    <v-app-bar color="#FFFFFF" app class="navbar__container" elevation="0">
      <div class="navbar__layout">
        <section class="navbar__layout__actions">
          <v-btn
            @click="changeMenuStatus"
            color="#1876D2"
            icon
            elevation="0"
            small
          >
            <v-icon color="#1876D2">mdi-menu</v-icon>
          </v-btn>

          <span class="page__indicator">{{ routeName }}</span>
        </section>

        <section class="options__contain">
          <NavbarNotification />
          <Help />
          <NavbarMenu />
        </section>
      </div>
    </v-app-bar>
  </main>
</template>

<script>
import Sidebar from "@/components/layouts/sidebar/Sidebar.vue";
import NavbarNotification from "@/components/layouts/navbar/NavbarNotification.vue";
import Help from "@/components/modules/help/chat/Help.vue";
import NavbarMenu from "@/components/layouts/navbar/NavbarMenu.vue";

export default {
  name: "TheNavbar",

  data: () => ({
    drawer: null,
  }),

  computed: {
    routeName() {
      const routePath = this.$route.path;
      const routerOptions = this.$router.options;

      const routeData = routerOptions.routes.find(
        (route) => route.path === routePath
      );

      return routeData.completeName;
    },
  },

  components: {
    Sidebar,
    NavbarNotification,
    Help,
    NavbarMenu,
  },

  methods: {
    changeMenuStatus() {
      this.drawer = !this.drawer;
    },
  },
};
</script>

<style lang="scss">
.navbar__main {
  .navbar__container {
    position: fixed !important;

    .navbar__layout {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .navbar__layout__actions {
        display: flex;
        align-items: center;

        .page__indicator {
          font-size: 14px;
          font-weight: 500;
          margin-left: 10px;
        }
      }

      .options__contain {
        display: flex;
        align-items: center;
        gap: 10px;

        .divider {
          height: 35px;
          width: 1px;
          background: #ebebeb;
        }
      }
    }
  }
}
</style>
